module.exports = __webpack_public_path__ + "pstatic/img/report3.19db25a3.png";